<template>
    <div>
        <div style="width:250px" v-if="!plan">
            <b-card>
                <b-card-title>Hämta data</b-card-title>
                <b-card-body>
                    <b>Datum:</b><br>
                    <datepicker v-model="currDate" :stepper="true">
                    </datepicker>
                    <!-- {{ currDate }} -->
                    <br>
                    <b-button variant="primary" @click="loadDay()">Hämta data</b-button>
                </b-card-body>
            </b-card>
        </div>
        <b-card v-if="plan">
            <b-card-title>
                <h5>Planering {{ plan.date }}</h5>
            </b-card-title>
            <b-card-body>
                <b-row>
                    <b-col>
                        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                            <b-button-group>
                                <b-button size="sm" @click="mapvisible = !mapvisible"><b-icon icon="map"></b-icon>
                                    Karta</b-button>
                            </b-button-group>
                            <b-button-group>
                                <b-button variant="outline-secondary">Urval: {{ getSelectedRoutes().length }}</b-button>
                                <b-button size="sm" title="Markera/Avmarkera alla" @click="toggleSelection()">
                                    <i class="fa-solid fa-check-double"></i> </b-button>
                                <b-button size="sm" title="Beräkna färdväg för valda rutter"
                                    @click="calcRouteDriveForSelected()"><i class="fa-solid fa-route"></i></b-button>
                                <b-button size="sm" title="Visa rutter på kartan" @click="selectedShowRouteOnMap()"><i
                                        class="fa-regular fa-map"></i></b-button>
                                <b-button size="sm" title="Geokoda valda rutter" @click="selectedAutoGeoCode()"><i
                                        class="fa-solid fa-map-pin"></i></b-button>
                                <b-button size="sm" title="Optimera körordning för valda rutter"
                                    @click="selectedOptimizeRoute()">
                                    <i class="fa-solid fa-brain"></i>
                                </b-button>
                            </b-button-group>
                            &nbsp;
                            <b-button-group>
                                <b-button size="sm" title="Valda stopp" variant="outline-primary" draggable="true"
                                    @dragstart="dragCartStart($event)" @dragover.prevent
                                    @click="cartContentModal = true">
                                    <i class="fa-solid fa-cart-shopping"></i>
                                    Urval
                                    <b-badge v-if="selectedStops && selectedStops.length > 0" variant="secondary">{{
                                        selectedStops.length }}</b-badge>
                                </b-button>
                                <b-button size="sm" title="Töm urval" variant="outline-primary"
                                    @click="selectedStops = []">
                                    <i class="fa-solid fa-cart-shopping"></i>
                                    <i class="fa-regular fa-circle-xmark"></i>
                                </b-button>
                            </b-button-group>
                            <b-spinner v-if="isBusy"></b-spinner>
                        </b-button-toolbar>
                    </b-col>
                    <b-col>
                        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                            <b-button-group>

                                <b-button size="sm" title="Stäng plan och öppna ny" @click="cancelPlan()">
                                    <i class="fa-solid fa-rectangle-xmark"></i> Stäng
                                </b-button>
                                <b-button size="sm" title="Spara plan" @click="savePlan()">
                                    <i class="fa-solid fa-download"></i>
                                </b-button>
                                <b-button size="sm" title="Öppna sparad plan" @click="loadPlan()">
                                    <i class="fa-solid fa-upload"></i>
                                </b-button>
                                <!-- <b-button size="sm" title="Aktivera denna plan" @click="activatePlanUi()">
                                    <i class="fa-solid fa-play"></i>
                                </b-button>
                                <b-button v-if="autoImplement" size="sm" variant="secondary"
                                    title="Aktivera plan automatiskt är PÅ" @click="autoImplement = false">
                                    <i class="fa-solid fa-rotate"></i>
                                </b-button>
                                <b-button v-if="!autoImplement" size="sm" variant="outline-secondary"
                                    title="Aktivera plan automatiskt är AV" @click="autoImplement = true">
                                    <i class="fa-solid fa-rotate"></i>
                                </b-button> -->

                                <b-button size="sm" variant="outline-secondary">{{ currDate }}</b-button>
                            </b-button-group>

                        </b-button-toolbar>

                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="1">
                        <tourlistVue :tours="plan.tours" @expand="ontourexpand" @setdrag="onsetdrag($event)"
                            @drop="ondrop($event)" :touractions="touractions" @touraction="handleTourAction($event)">
                            <b-button size="sm" variant="light" title="Lägg till tur" @click="addTour()">+</b-button>
                        </tourlistVue>
                    </b-col>
                    <b-col>
                        <planpad :lanes="lanes" :cmds="routecommands" :selectedStops="selectedStops"
                            :selectedRoute="currRoute" @drop="ondrop($event)" @setdrag="onsetdrag($event)"
                            @geocoded="onGeoCoded($event)" @autogeocode="onAutoGeoCode($event)"
                            @setselect="onsetselect($event)" @mapcommand="onmapcommand($event)" @cmd="onCmd($event)"
                            @isolateaction="isolateAction($event)">
                        </planpad>
                    </b-col>
                </b-row>
            </b-card-body>
            <!-- <iframe src="/map/index.html" width="100%" height="1200px"></iframe> -->
            <b-sidebar id="sidebar-1" title="Karta" shadow no-header v-model="mapvisible" :right="true"
                :width="`${mapWidth}px`">
                <div>

                    <!-- <header class="b-sidebar-header"><button type="button" aria-label="Close" class="close text-dark"><svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="x" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-x b-icon bi"><g><path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"></path><path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"></path></g></svg></button><strong id="sidebar-1___title__">Karta</strong></header> -->
                    <!-- <b-header> -->
                    <!-- <div style="position:absolute;top:10px;left:-10px" @mousemove="moveMapSize($event)">
                            <i class="fa-solid fa-arrows-left-right-to-line"></i>
                        </div>                                               -->
                    <h4 id="sidebar-no-header-title">
                        <b-button variant="light" draggable="true" @dragstart="sidebarDragStart($event)"
                            :style="{ position: 'absolute', 'left': '10px', 'top': `${mapHeight}px` }"
                            @drag="moveMapSize($event, true, true)" title="Justera storlek" size="sm">
                            <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                        </b-button>
                        <b-button variant="light" draggable="true" @dragstart="sidebarDragStart($event)"
                            @drag="moveMapSize($event, true, false)" title="Justera bredd" size="sm">
                            <i class="fa-solid fa-left-right"></i>
                        </b-button>

                        <b-button variant="light" title="Dölj kartan" @click="mapvisible = false"><i
                                class="fa-solid fa-x"></i></b-button>
                        Karta
                    </h4>
                    <!-- </b-header> -->
                    <iframe ref="mapiframe" src="/map/index.html" width="100%" :height="`${mapHeight}px`"></iframe>
                </div>
            </b-sidebar>
            <b-modal v-model="cartContentModal" ok-only>
                <b-card>
                    <b-card-title>
                        Valda stopp
                    </b-card-title>
                    <b-card-header>
                        <b-row>
                            <b-col>
                                Antal: {{ selectedStops.length }}
                            </b-col>
                            <b-col>
                                <b-button size="sm" title="Töm urval" variant="outline-primary"
                                    @click="selectedStops = []">
                                    <i class="fa-solid fa-cart-shopping"></i>
                                    <i class="fa-regular fa-circle-xmark"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col>
                                <b-list-group v-for="(ss, i) in selectedStops" :key="i">
                                    <b-list-group-item>
                                        <b-button size="sm" title="Ta bort ur urval"
                                            @click="removeStopFromSelection(ss.stop)">
                                            <i class="fa-solid fa-circle-xmark"></i>
                                        </b-button>
                                        {{ ss.stop.text }}</b-list-group-item>
                                </b-list-group>
                            </b-col>
                        </b-row>

                    </b-card-body>
                </b-card>
            </b-modal>
            <b-modal v-model="routeSettingsDialogVisible" title="Inställningar för rutten" ok-only
                @ok="updateRouteSettings(routeSettingsRoute)">
                <b-card v-if="routeSettingsRoute">
                    <b-card-title>Inställningar för rutten</b-card-title>
                    <b-card-body>
                        <b-row>
                            <b-col>
                                <b-form-group label="Ruttens namn:">
                                    <b-form-input v-model="routeSettingsRoute.name"
                                        placeholder="Namn på rutt"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Terminal:">
                                    <b-form-select v-model="routeSettingsRoute.defaultStartPlaceId"
                                        :options="getDefaultPlaceItems()"></b-form-select>
                                </b-form-group>
                                <b-form-group label="Avgåndstid:">
                                    <b-form-input type="time" v-model="routeSettingsRoute.startTime"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-modal>
            <b-modal v-model="geoAreaVisible" v-if="geoAreaCmd" ok-only>
                <geoarea :cmd="geoAreaCmd" :data="geoAreaData" @cmd="ongeoareacmd($event)"></geoarea>
            </b-modal>

        </b-card>
        <b-card v-if="plan">
            <b-button @click="Test()">Test</b-button>
            <b-button @click="copyToClipBoard(plan)">Kopiera plan till urklipp JSON</b-button>
        </b-card>

    </div>
</template>
<script>
import tourlistVue from './tourlist.vue';
import planpad from './planpad.vue';
import datepicker from '@/components/datepicker.vue';
import moment from "moment";
import { Api } from "../../lib/api";
const api = new Api();
// import { Config, ConfigItem } from '@/lib/config'
import { PlanManager } from "../../lib/geo";
import Geoarea from './geoarea.vue';
import Settings from "../../lib/settings";


//TODO: Get from server
const basicSettings = {
    places: [
        {
            id: 1, //This must correspond to geoPlace table
            name: 'SODEXO',
            street: 'Bruttovägen 9',
            street2: '',
            postCode: '17532',
            city: 'Järfälla',
            country: 'SE',
        }
    ],
    route: {
        defaultStartPlaceId: 1,
        defaultEndPlaceId: 1,
    },
    geoCode: {
        limitZones: []
    },
    geoZones:
        [
            {
                name: 'Geokodbegränsning',
                description: 'Begränsar totala arbetsområdet',
                points: [
                    {
                        "geoX": 17.204589843750004,
                        "geoY": 60.04473223028856
                    },
                    {
                        "geoX": 16.375122070312504,
                        "geoY": 59.65849223341032
                    },
                    {
                        "geoX": 16.721191406250004,
                        "geoY": 59.124286139862974
                    },
                    {
                        "geoX": 18.028564453125004,
                        "geoY": 58.855435678021024
                    },
                    {
                        "geoX": 19.193115234375004,
                        "geoY": 59.267752119231915
                    },
                    {
                        "geoX": 19.489746093750004,
                        "geoY": 59.882506081939766
                    },
                    {
                        "geoX": 18.654785156250004,
                        "geoY": 60.41837228799086
                    },
                    {
                        "geoX": 17.352905273437504,
                        "geoY": 60.102282220406806
                    }
                ]
            }
        ]
};

// basicSettings.stopConsolidate = {
//     maxGeoX: 0.0005,
//     maxGeoY: 0.0005,
//     sameGeoId: false,
// }

const pm = new PlanManager(basicSettings, api);

export default {
    name: 'plan',
    components: { tourlistVue, planpad, datepicker, Geoarea },
    data() {
        return {
            currDate: moment(new Date()).format("YYYY-MM-DD"),
            lanes: [],
            currRoute: null, //Selected route            
            currDrag: null,
            mapvisible: true,
            mapWidth: 650,
            mapHeight: 700,
            isBusy: false,
            //tours: null,
            plan: null,
            pm: null,
            selectedStops: [],
            cartContentModal: false,
            geoAreaVisible: false,
            geoAreaCmd: null,
            geoAreaData: null,
            routeSettingsDialogVisible: false,
            routeSettingsRoute: null,
            horizDrag: null,
            autoSaveTimeout: null,
            autoImplement: false,
            touractions: [{ title: 'Lägg till rutt', cmd: 'addroute' },
                // {title:'Optimera körordning', cmd:'optimizesortorder'},
            ],
            routecommands: [
                {
                    cmd: 'routeSettings', text: 'Ruttinställningar', title: '', icon: 'fa-gear',
                    oncmd: (ev) => this.routeSettingsDialog(ev.route)
                },
                {
                    cmd: 'autogeocode', text: 'Autogeokoda rutt', title: 'Låt GEO försöka geokoda per automatik', icon: 'fa-map-pin',
                    oncmd: (ev) => this.autoGeoCodeBookings(ev.route)
                },
                {
                    cmd: 'activate', text: 'Aktivera rutt', title: 'Aktivera rutten i Transplanet', icon: 'fa-play',
                    oncmd: (ev) => this.activateRouteUi(ev.route)
                },
                {
                    cmd: 'optimizesortorder', text: 'Optimera körordning', title: 'Låt GEO optimera körordningen', icon: 'fa-brain',
                    oncmd: (ev) => this.optimizeRoute(ev.route)
                },
                {
                    cmd: 'showonmap', text: 'Visa på karta', title: 'Visa rutten på kartan', icon: 'fa-map',
                    oncmd: (ev) => this.showRouteOnMap(ev.route)
                },
                {
                    cmd: 'refreshroute', text: 'Räkna om rutt', title: 'Räkna om rutten', icon: 'fa-calculator',
                    oncmd: (ev) => this.refreshRoute(ev.route)
                },

                // {
                //     cmd: 'routesettings', text: 'Inställningar', title: 'Inställningar för rutten', icon: 'fa-gear',
                //     oncmd: (ev) => this.routeSettingsDialog(ev.route)
                // },                
                {
                    cmd: 'setNameOnRoute', text: 'Byt resurs', title: '', icon: 'fa-truck',
                    oncmd: (ev) => this.setNameOnRoute(ev.route)
                },

                {
                    cmd: 'copyroutejson', text: 'DEBUG_ruttJson', title: '', icon: 'fa-bug',
                    oncmd: (ev) => this.copyToClipBoard(ev.route)
                },
            ]
        }
    },
    created() {
        this.geoGetRouteSettingsLogic();
        localStorage.setItem('mapCommandUrl', Settings.instanceSpecific().mapcommandUrl);
        this.clearPlan();
        this.resetPlanFromLs();

    },
    mounted() {
        // Listen for messages from the iframe        
        window.addEventListener('message', this.handleMessage);
        this.autoSaveTimeout = setInterval(this.savePlanToLs, 10000);

        pm.geoCodeDefaultStops();
        this.updateMapSize();
    },
    beforeDestroy() {
        // Clean up the event listener when the component is destroyed
        window.removeEventListener('message', this.handleMessage);
        clearInterval(this.autoSaveTimeout);
    },
    methods: {
        loadDay() {
            this.clearPlan();
            this.getData(null, true);
        },
        getData(route, refreshAll) {
            //this.tours = examplePlan.tours;

            var p = {
                deliveryDateText: this.currDate
            };
            if (route) {
                p.route = route.resource;
                p.tour = route.tourName;
            } else if (!refreshAll) {
                console.log('No route, and not allday. Do nothing!');
                return;
            }
            this.isBusy = true;
            api.get('/api/geo/GetBookingsForDate?' + api.params(p)).then(res => {
                //TODO: Hantera partial update!!!
                //              if(refreshAll) {                
                var name = '(Namnlös)';
                pm.plan = new pm.Plan(this.currDate, name);
                var bs = res.data;
                bs.map(b => pm.addBookingToPlan(b));
                // } else {
                //     //Partial update
                //     res.data.map(b => pm.addBookingToPlan(b));
                // }
                this.plan = pm.plan;
                pm.refreshPlan(); //För specifik route?
                this.refreshLanes();
                //this.plan = this.createPlanFromBookings(res.data, route);
                this.isBusy = false;
            });
        },
        geoGetRouteSettingsLogic() {
            api.get('/api/geo/GetSettingsLogic').then(res => {
                basicSettings.routeSettings = res.data.routeSettingsItems;
                basicSettings.routeSettings.sort((a, b) => {
                    const sortA = (a.tourName ? 2 : 0) + (a.terminalName ? 1 : 0);
                    const sortB = (b.tourName ? 2 : 0) + (b.terminalName ? 1 : 0);
                    return sortB - sortA;
                });
                var defVal = basicSettings.routeSettings.find(x => x.tourName == null && x.terminalName == null);

                basicSettings.params = {
                    stopConsolidate_maxGeoX: '0.01',
                    stopConsolidate_maxGeoY: '0.01',
                    stopConsolidate_sameGeoId: '0',
                }; //Set default params
                res.data.planSettingsItems.map(x => {
                    basicSettings.params[x.keyName] = x.value;
                });

            });
        },
        refreshLanes() {
            this.lanes.map(l => this.refreshlane(l));
        },
        refreshlane(lane) {
            var routes = [];

            for (var i = 0; i < lane.routes.length; i++) {
                var r = lane.routes[i];
                var newRoute = this.plan.routes.find(x => x.tourName == r.tourName && x.resource == r.resource);
                if (!newRoute)
                    console.log('Underlig lane');
                else
                    routes.push(newRoute);
            }
            lane.routes = routes; //Create a new object
        },
        getSelectedRoutes() {
            var res = [];
            if (this.plan.routes)
                res = this.plan.routes.filter(x => x.selected);
            return res;
        },
        toggleSelection() {
            if (this.plan.routes.length > 0) {
                var v = !this.plan.routes[0].selected;
                this.plan.routes.map(x => x.selected = v);
            }
        },
        calcRouteDriveForSelected() {
            this.getSelectedRoutes().map(r => pm.CalcRouteDriveForRoute(r));

        },



        // createPlanFromBookings(bs, route) {
        //     var tourNames = [...new Set(bs.map(b => b.tour))]; //Case
        //     var resourceNames = [...new Set(bs.map(b => b.resource))]; //Case
        //     //var tourResCombs =  [...new Set(bs.map(b => `${b.resource}|${b.tour}`))]; //Case

        //     let uniqueId = 1;
        //     var tours = [];
        //     var routes = []; //Do we need this? Yes!  

        //     tourNames.map(tName => {
        //         var t = { id: uniqueId++, name: tName, routes: [], expanded: false }; //new Tour
        //         resourceNames.map(rName => {
        //             var rbs = bs.filter(x => x.tour == tName && x.resource == rName);
        //             if (rbs.length > 0) {
        //                 var r = {
        //                     id: uniqueId++,
        //                     name: rName,
        //                     bookings: rbs,
        //                     tourName: tName,
        //                     resource: rName,
        //                     stops: [], //TODO: Create from bookings                            
        //                 }; //new Route
        //                 t.routes.push(r);
        //                 routes.push(r);
        //                 //this.addOrUpdateRoute(r);
        //                 this.reCreateStopsForRoute(r);
        //             }

        //         });
        //         tours.push(t);
        //     })

        //     //new Plan
        //     let p = {
        //         date: this.currDate,
        //         tours: tours,
        //         routes: routes,
        //     }

        //     return p;
        // },
        addOrUpdateRoute(newRoute) {
            var oldR = this.plan.routes.find(x => x.tourName == route.tourName && x.resource == route.resource);
            if (oldR) {
                this.plan.routes.filter(x => x !== oldR);
                var t = this.tours.find(t => t.name == newRoute.tourName);
                if (!t) {
                    t = { id: uniqueId++, name: newRoute.tourName, routes: [], expanded: false };
                    this.tours.push(t) //New tour
                }
                var tIdx = t.routes.findIndex(x => x.resource == newRoute.resource);
                if (tIdx > 0)
                    t.routes.push(newRoute)
                else
                    t.routes[tIdx] = newRoute;

                this.lanes.map(l => {
                    for (var i = 0; i < l.routes.length; i++)
                        if (l.routes[i] == oldR)
                            l.routes[i] == route;
                });
            }
            this.plan.routes.push(newRoute);
        },
        reCreateStopsForRoute(r) {
            var stops = [];
            var missingGeos = [];
            stops.push(this.createDefaultStop(basicSettings.route.defaultStartPlaceId, 1));
            stops.push(this.createDefaultStop(basicSettings.route.defaultEndPlaceId, 99999));

            r.bookings.map(b => {
                if (!this.pushAction(stops, b.pickup, { type: 'PU', booking: b }))
                    missingGeos.push(b.pickup);
                if (!this.pushAction(stops, b.delivery, { type: 'DLV', booking: b }))
                    missingGeos.push(b.delivery);
            });
            //Missing geos är nu av typen place
            r.missingGeos = missingGeos.filter((value, index, self) => self.findIndex(x => JSON.stringify(value) == JSON.stringify(x)) === index);
            r.stops = stops;
        },
        createDefaultStop(placeId, sortOrder) {
            var f = basicSettings.places.find(x => x.id == placeId);
            if (f)
                return {
                    sortOrder: sortOrder,
                    locked: true,
                    text: f.terminalName, //'TERMINAL',
                    place: { ...f },
                    actions: [], // {type:'PU/DLV', booking: {...}}
                } //New stop
        },
        pushAction(stops, place, action) {

            if (!place || !place.geo) //Missing geo
                return false;

            let minIdx = 0;
            if (action.type == 'DLV') {
                //TODO://Must check if PICKUP is before                
                var puIdx = stops.findIndex(s => s.actions.findIndex(a => a.booking.id == action.booking.id && a.type == 'PU') >= 0);
                if (puIdx > 0)
                    minIdx = puIdx + 1; //Cannot be same stop
            }
            //Check for stops with same geoId
            var currStop = null;
            for (var currIdx = minIdx; currIdx < stops.length && !currStop; currIdx++) {
                var s = stops[currIdx];
                if (s.place && s.place.geo && s.place.geo.id == place.geo.id)
                    currStop = s;
            }

            if (!currStop) {
                currStop = {
                    //sortOrder: 2, //Default sortorder, between 
                    locked: false,
                    text: `${place.street},${place.city}`,
                    place: place,
                    actions: [],
                    sortOrder: stops.length,
                }; //New stop                
                stops.splice(stops.length - 1, 0, currStop); //Add just before end of route
            }
            currStop.actions.push(action);

            return true;
        }
        , ontourexpand(ev) {
            var t = this.plan.tours.find(x => x.name == ev.tour.name);
            if (t)
                t.expanded = ev.expanded;
            // this.$forceUpdate();
        },
        onsetdrag(ev) {
            console.log('Drag is set of type:' + ev.type);
            this.currDrag = ev;
        },
        ondrop(ev) {
            var dest = ev;
            //Now, dest and src has same format, i.e. with type

            if (!this.currDrag) {
                alert('Finns inget att droppa');
                return;
            }

            var drags = [this.currDrag];
            if (this.currDrag.type == 'drags')
                drags = this.currDrag.drags;

            drags.map(src => {
                //var src = this.currDrag;
                console.log(`Drop ${src.type} to ${dest.type}`);
                if (dest.type == 'lane') {
                    var destLane = this.lanes.find(x => x.name == dest.lane.name);

                    switch (src.type) {
                        case 'route':
                            if (destLane.routes.findIndex(x => x.name == src.route.name) >= 0) {
                                //Already there
                                alert('Finns redan en'); //TODO: Ta bort denna alert
                                return;
                            }
                            if (src.lane)
                                src.lane.routes = src.lane.routes.filter(x => x !== src.route);
                            destLane.routes.push(src.route);
                            src.route.expanded = true;
                            break;

                        case 'tour':
                            var t = this.plan.tours.find(x => x.name == src.tour.name); //id?
                            if (!t) {
                                alert('Känner inte igen turen');
                                return;
                            }
                            t.routes.map(r => destLane.routes.push(r));

                            break;

                        case 'tourlist':
                            this.plan.routes.map(r => destLane.routes.push(r));
                            break;

                    }
                }
                if (src.type == 'action' && dest.type == 'route') {
                    var srcRoute = pm.plan.routes.find(x => x.id == src.routeId);
                    var destRoute = dest.route; // pm.plan.routes.find(x => x.id == dest.routeId);
                    pm.MoveActionBetweenRoutes(src.action, srcRoute, destRoute);
                    pm.refreshPlan();
                    this.refreshSelectedStops();
                }
                if (src.type == 'action' && dest.type == 'stop') {
                    var srcRoute = pm.plan.routes.find(x => x.id == src.routeId);
                    var destRoute = pm.plan.routes.find(x => x.id == dest.routeId);
                    if (srcRoute != destRoute) {
                        alert('Kan inte flytta enstaka åtgärd mellan olika rutter. Flytta hela stoppet istället.');
                        return;
                    }
                    if (confirm(`Vill du flytta\n${src.action.booking.name}\ntill\n${dest.stop.text}?`)) {
                        pm.MoveActionToStop(src.action, dest.stop, destRoute);
                        pm.refreshPlan();
                        this.refreshSelectedStops();
                    }
                }
                if (src.type == 'stop' && dest.type == 'route') {
                    var srcRoute = pm.plan.routes.find(x => x.id == src.routeId);
                    var destRoute = dest.route; // pm.plan.routes.find(x => x.id == dest.routeId);
                    var s = src.stop;
                    if (s && !s.locked)
                        s.actions.map(a => pm.MoveActionBetweenRoutes(a, srcRoute, destRoute));
                    else
                        alert('Går inte att flytta');

                    this.setSelectedRoute(destRoute);
                    pm.refreshPlan();
                    this.refreshSelectedStops();
                }
                if (src.type == 'stop' && dest.type == 'stop') {
                    //Change order?                
                    if (src.stop.locked) {
                        alert('Detta stopp är låst och går inte att flytta.');
                        return;
                    }

                    var srcRoute = pm.plan.routes.find(x => x.id == src.routeId);
                    var destRoute = pm.plan.routes.find(x => x.id == dest.routeId);

                    if (srcRoute == destRoute) {
                        //Change order
                        //Stoppa in idiotstopp vid destination
                        pm.MoveStopToPosition(destRoute, src.stop, dest.idx);
                        pm.refreshPlan();
                        this.setSelectedRoute(destRoute);
                    } else {
                        var s = src.stop;
                        //Samma som stop => route. TODO: Lägg in i rätt idx
                        if (s && !s.locked && s.actions.length > 0) {
                            var act = s.actions[0];
                            s.actions.map(a => pm.MoveActionBetweenRoutes(a, srcRoute, destRoute));
                            //Find the new stop at destination
                            var deststop = destRoute.stops.find(x => x.actions.indexOf(act) >= 0);
                            if (deststop) //Should always be
                                pm.MoveStopToPosition(destRoute, deststop, dest.idx);
                        }
                        else
                            alert('Går inte att flytta');
                        pm.refreshPlan();
                        this.setSelectedRoute(destRoute);
                    }
                    this.refreshSelectedStops();
                }
                if (src.type == 'tour' && dest.type == 'tour') {
                    //Move position of tour in tourList                 
                    const srcIdx = pm.plan.tours.findIndex(x => x.id == src.tour.id);
                    const destIdx = pm.plan.tours.findIndex(x => x.id == dest.tour.id);
                    if (srcIdx >= 0 && destIdx >= 0 && srcIdx != destIdx) {
                        var o = pm.plan.tours.splice(srcIdx, 1)[0];
                        pm.plan.tours.splice(destIdx, 0, o);
                    }
                }
            })

            pm.refreshPlan();
            //this.currDrag = null;
        },
        onGeoCoded(ev) {
            console.log('Remove missing geos');
            //Refresh route
            if (ev.route)
                this.getData(ev.route);
            else
                console.log('onGeocoded - no route to update!')
            //alert('geocoded');
        },
        autoGeoCodeBookings(route) {
            var bIds = route.bookings
                .filter(x => this.isBookingMissingGeo(x))
                .map(x => x.id);
            this.isBusy = true;
            api.post('/api/geo/AutoGeocodeBookings', bIds).then(res => {
                this.isBusy = false;
                var affectedIds = res.data;
                if (affectedIds.length > 0)
                    this.getData(route);
            })
        },
        selectedAutoGeoCode() {
            this.getSelectedRoutes().map(r => this.autoGeoCodeBookings(r));
            if (r === this.currRoute)
                this.showRouteOnMap(this.currRoute);
        },
        selectedOptimizeRoute() {
            this.getSelectedRoutes().map(r => this.optimizeRoute(r));
        },
        optimizeRoute(r) {
            pm.OptimizeSortOrderForRoute(r);
            if (r === this.currRoute)
                this.showRouteOnMap(this.currRoute);
        },
        isBookingMissingGeo(b) {
            return !(b.pickup.geo && b.delivery.geo);
        },
        onAutoGeoCode(ev) {
            this.autoGeoCodeBookings(ev);
        },

        copyToClipBoard(v) {
            navigator.clipboard.writeText(JSON.stringify(v));
            console.log(v);
        },
        onsetselect(ev) {
            //alert('Framme')
            var r = ev.route;
            var fr = this.plan.routes.find(x => x.name == r.name && x.tourName == r.tourName);
            fr.selected = ev.selected;
            ev.route.selected = ev.selected;
        },

        /* MAPCOMMAND */
        handleMessage(ev) {
            //Handle and detect incoming message from iFrame
            var h1 = this.$refs.mapiframe;

            if (h1 && h1.contentWindow && ev.source == h1.contentWindow) {
                var msg = JSON.parse(ev.data);

                switch (msg.cmd) {
                    case 'mapready':
                        //Map is ready to use
                        this.updateMapSize();
                        break;

                    case 'click':
                        var m = msg.data.marker;
                        var r = pm.plan.routes.find(x => x.id == m.routeId);
                        //var s = r.stops[m.stopIdx];
                        var s = r.stops.find(x => x.stopId == m.stopId);
                        this.addStopToSelection(r, s);
                        break;

                    case 'savearea':
                    case 'loadarea':
                        this.geoAreaVisible = true;
                        this.geoAreaCmd = msg.cmd;
                        this.geoAreaData = msg.data;

                }

                //TODO: Handle the message
            }
        },
        addStopToSelection(r, s) {
            var ss = { route: r, stop: s };
            //this.selectedStops = this.selectedStops.filter(x => !(x.stop == ss.stop && x.route == ss.route));
            this.selectedStops = this.selectedStops.filter(x => !(x.stop.stopId == ss.stopId));
            this.selectedStops.push(ss);
            this.refreshSelectedStops();
        },
        removeStopFromSelection(s) {
            this.selectedStops = this.selectedStops.filter(x => !(x.stop == s));
            this.refreshSelectedStops();
        },
        refreshSelectedStops() {
            //Must remove stops that has been moved
            this.selectedStops = this.selectedStops.filter(x => x.route.stops.findIndex(s => s.stopId == x.stop.stopId) >= 0);
        },
        sendMapCommand(cmd, data) {
            var h1 = this.$refs.mapiframe;
            var cmdJson = JSON.stringify({ cmd: cmd, data: data });            
            h1.contentWindow.postMessage(cmdJson, Settings.mapcommandUrl);
        },
        onmapcommand(ev) {
            this.sendMapCommand(ev.cmd, ev.data)
        },
        selectedShowRouteOnMap() {
            this.sendMapCommand('clear');
            var markers = [];
            this.getSelectedRoutes().map(r => markers = markers.concat(this.addRouteToMap(r)));
            this.sendMapCommand('fitbounds', { markers: markers });
        },
        showRouteOnMap(r) {
            this.sendMapCommand('clear');
            var markers = this.addRouteToMap(r);
            this.sendMapCommand('fitbounds', { markers: markers });
        },
        addRouteToMap(r) {
            //color of route
            var color = r.color;
            if (r === this.currRoute)
                color = '#ff0000';//red
            if (!color)
                color = '#28f61f';

            var stopIdx = 0;
            var markers = r.stops.map(s => {
                if (!s || !s.place || !s.place.geo) {
                    console.warn(`Stop has no data, route: ${r.name}, stop: ${stopIdx}`);
                    return null; //Skip this stop
                }
                var p = s.place;
                return {
                    geoX: p.geo.geoX,
                    geoY: p.geo.geoY,
                    title: p.geo.name,
                    id: p.id,
                    color: s.locked ? 'black' : color,
                    routeId: r.id,
                    stopId: s.stopId,
                    stopIdx: stopIdx++
                }
            }).filter(x => x != null); //Remove nulls

            this.sendMapCommand('setmarkers', { markers: markers, events: { click: true } });
            if (r.geometry)
                this.sendMapCommand('setroute', { geometry: r.geometry, color: color });
            //TODO: Check if there is a geometry too
            return markers;
        },
        getMarkerText(s) {
            var res = [s.place.geo.name];
            var bs = s.actions
        },
        addTour() {
            var tName = prompt('Ange namn på turen:');
            if (tName)
                pm.addTour(tName);
        },
        handleTourAction(ev) {
            switch (ev.cmd) {
                case 'addroute':
                    var rname = prompt('Ange namn på rutten');
                    if (rname) {
                        var r = pm.getOrAddRoute(ev.tour.name, rname);
                        var t = pm.plan.tours.find(x => x.name == ev.tour.name);
                        t.routes.push(r);
                    }
                    break;
                default:
                    alert('Felaktigt kommando');
            }
        },
        cancelPlan() {
            if (confirm('Vill du stänga planen? OBS! Alla osparade förändringar går förlorade.'))
                this.clearPlan();
        },
        clearPlan() {
            this.plan = null;
            this.selectedStops = [];
            this.lanes = [];
            const lanesCount = 5;
            for (var i = 0; i < 5; i++)
                this.lanes.push({ name: `#${i + 1}`, routes: [] });
        },
        savePlanToLs() {
            var currPlan = JSON.stringify(this.plan);
            var lsPlan = localStorage.getItem('plan');
            localStorage.setItem('plan', currPlan);

            if (lsPlan && currPlan != lsPlan && this.autoImplement) {
                //this.planNotImplemented = true;
                //Replaced by save plane per route
                // if (!this.arePlansEqual(this.plan, JSON.parse(lsPlan)))
                //     this.activatePlan();
            }
        },
        arePlansEqual(p1, p2) {
            var b1 = this.getSortListForPlan(p1);
            var b2 = this.getSortListForPlan(p2);
            return JSON.stringify(b1) == JSON.stringify(b2);
        },
        resetPlanFromLs() {
            var pc = localStorage.getItem('plan');
            if (pc) {
                var newPlan = JSON.parse(pc);
                this.plan = newPlan;
                pm.plan = newPlan; //Funkar detta?
                pm.refreshPlan();

                this.refreshLanes();
            }
        },
        savePlan() {
            //TODO: Handle same name problem
            var name = prompt('Ange namn för planen:', this.plan.name)
            if (name) {
                this.isBusy = true;
                this.plan.name = name;

                var pl = this.plan;
                var p = {
                    id: pl.planId,
                    period: pl.period,
                    name: pl.name,
                    planContent: JSON.stringify(this.plan)
                }

                api.post('/api/geo/SavePlan', p).then(res => {
                    this.plan.planId = res.data;
                    this.isBusy = false;
                })
            }
        },
        loadPlan() {
            if (!this.plan.planId) {
                alert('Kan inte hitta gammal plan.');
                return;
            }
            if (this.plan.planId) {
                if (confirm('Återgår till senast sparad plan?')) {
                    this.isBusy = true;
                    api.get('/api/geo/GetPlan?planId=' + this.plan.planId).then(res => {
                        var pc = res.data.planContent;
                        var newPlan = JSON.parse(pc);
                        this.plan = newPlan;
                        pm.plan = newPlan; //Funkar detta?
                        pm.refreshPlan();

                        this.refreshLanes();

                        this.isBusy = false;
                        alert('Ny plan uppladdad');
                    });
                }
            }
        },

        activatePlanUi() {
            alert("Aktivering av plan görs för respektive rutt. Välj rutt och klicka på 'Aktivera rutt' i menyn.");
            // if (confirm('Vill du aktivera planen i Transplanet?')) {
            //     this.isBusy = true;

            //     this.activatePlan();
            // }
        },
        activateRouteUi(r) {
            if (confirm(`Vill du aktivera rutten '${r.name}' i Transplanet?`)) {
                this.isBusy = true;
                var bsort = this.getSortListForRoute(r);
                api.post('/api/geo/ActivatePlan', bsort).then(res => {
                    this.isBusy = false;
                });
            }
        },
         activatePlan() {
            var bsort = this.getSortListForPlan(this.plan);

            api.post('/api/geo/ActivatePlan', bsort).then(res => {
                this.isBusy = false;
            });

        },
        getSortListForPlan(p) {
            var bsort = [];

            //Om det är en hämtorder, ska det vara pickup-aktiviteten som styr
            //Annars delivery

            p.routes.map(r => {
                var bsortR = this.getSortListForRoute(r);
                bsort = bsort.concat(bsortR);
            });
            return bsort;
        },
        
        getSortListForRoute(r) {
            var bsort = [];
            var startTime = r.startTime ? r.startTime : '08:00';
            var startDateTime = `${this.currDate} ${startTime}`
            var startm = moment(startDateTime, 'YYYY-MM-DD HH:mm');

            var arrTime;
            for (var i = 1; i < r.stops.length - 1; i++) {
                var s = r.stops[i];
                if (s.arrivalTime)
                    arrTime = startm.clone().add(s.arrivalTime, 'minutes').format('HH:mm');

                s.actions.map(a => {
                    var tp = a?.type;
                    var st = a?.booking?.serviceTypeId;
                    //Pickup or delivery? If pickup, use arrivalTime, else use arrivalTime + worktime
                    if ((tp == 'PU' && st == 20) || (tp == 'DLV' && st !== 20))
                        //Pickup for serviceType 20, or delivery for other serviceTypes
                        bsort.push({
                            id: a.booking.id,
                            idx: i,
                            tour: r.tourName,
                            resource: r.resource,
                            arrivalTime: arrTime,
                        });
                });
            }
            return bsort;
        },  
       
        onCmd(ev) {
            //alert('cmd')
            //TODO: Command registering
            var c = this.routecommands.find(x => x.cmd == ev.cmd);
            if (c && c.oncmd) {
                c.oncmd(ev);
                return;
            }

            switch (ev.cmd) {
                case 'stopselected':
                    //alert('stopselected');

                    if (ev.value)
                        this.addStopToSelection(ev.route, ev.stop);
                    else
                        //this.removeStopFromSelection(ev.stop);
                        this.selectedStops = this.selectedStops.filter(x => !(x.stop == ev.stop));
                    break;

                case 'autogeocode':
                    this.autoGeoCodeBookings(ev.route);
                    break;

                // case 'optimizesortorder':
                //     this.optimizeRoute(ev.route);
                //     break;

                case 'stopworktimechanged':
                    var r = ev.route;
                    var s = ev.stop;
                    pm.setStopWorkTime(r, s, ev.manWorkMinutes);
                    break;

                case 'selectroute':
                    this.currRoute = ev.route;
                    break;

                default:
                    alert('Unknown cmd:' + ev.cmd);
            }
            if (ev.route)
                this.setSelectedRoute(ev.route);
            //this.showRouteOnMap(this.currRoute); //Refresh map
        },
        setSelectedRoute(r) {
            this.currRoute = r;
            this.showRouteOnMap(this.currRoute); //Refresh map
        },
        dragCartStart(ev) {
            if (ev)
                ev.stopPropagation();

            var dragList = this.selectedStops.map(ss => {
                return { type: 'stop', stop: ss.stop, route: ss.route, routeId: ss.route.id }
            });
            var ctx = { type: 'drags', drags: dragList };
            this.onsetdrag(ctx);
        },
        routeSettingsDialog(r) {
            this.routeSettingsRoute = r;
            this.routeSettingsDialogVisible = true;
        },
        setNameOnRoute(r) {
            var newName = prompt('Ange resurs för rutten', r.resource);
            if (newName && newName != r.resource) {
                pm.setNameOnRoute(r, newName);
            }
        },

        refreshRoute(r) {
            pm.refreshRoute(r);
            this.currRoute = r;
            this.showRouteOnMap(this.currRoute);
        },
        sidebarDragStart(ev) {
            this.horizDrag = { x: ev.clientX, y: ev.clientY };
        },
        moveMapSize(ev, xActive, yActive) {
            console.log(ev);
            var newX = ev.clientX;
            var newY = ev.clientY;
            if (xActive && this.horizDrag && this.horizDrag.x) {
                var dx = newX - this.horizDrag.x;
                if (Math.abs(dx) < 100) {
                    this.mapWidth -= newX - this.horizDrag.x;
                    this.horizDrag.x = newX;
                }
            }
            if (yActive && this.horizDrag && this.horizDrag.y) {
                var dy = newY - this.horizDrag.y;
                if (Math.abs(dy) < 100) {
                    this.mapHeight += newY - this.horizDrag.y;
                    this.horizDrag.y = newY;
                }
                this.updateMapSize();
            }
        },
        updateMapSize() {
            this.sendMapCommand('setmapsize', { height: this.mapHeight });
        },
        ongeoareacmd(ev) {
            this.sendMapCommand(ev.cmd, ev.data);
        },
        getDefaultPlaceItems() {
            return basicSettings.places.map(p => {
                return {
                    value: p.id,
                    text: p.terminalName || p.name,
                }
            });
        },
        updateRouteSettings(r) {
            //Update route settings
            if (r) {
                if (r.defaultStartPlaceId && r.defaultStartPlaceId != r.stops[0].place.id)
                    //Change start place
                    pm.changeTerminalForRoute(r, r.defaultStartPlaceId);

            }
            this.routeSettingsDialogVisible = false;
            this.showRouteOnMap(r);
        },
        isolateAction(ev) {
            pm.isolateAction(ev.action, ev.stp, ev.route);
            pm.refreshPlan();
            this.setSelectedRoute(ev.route);
            this.refreshSelectedStops();
        }
    }
}

</script>
<style scoped>
.test {
    background-color: #a886bf
}

.adjusthorizontal {
    position: absolute;
}
</style>